<template>
  <div class="Flex Flex--d-c PageWrapper" id="PageWrapper" ref="PageWrapper">
    <div class="FlexItem childView">
      <div class="FlexItem">
        <div class="containerCls">
          <audio id="audioRef" autoplay src="../assets/empty.mp3"></audio>
          <div
            :class="{ MessageContainer: true, clearMarginCls: !isInputShow }"
          >
            <TopView
              :durationNum="globalDuration"
              @on-set-duration="setGlobalDuration"
              @on-ask="onPoke"
              :questionTips="questionTips"
              :guideTips="guideTips"
            />
            <div
              :class="['PullToRefresh', device == 'ios' ? 'iosMinHeight' : '']"
            >
              <div
                :class="{
                  'PullToRefresh-inner': true,
                  tourPaddingBottom: isTourShow,
                  inputPaddingBottom: isInputShow,
                  audioPaddingBottom: isAudioBarShow,
                }"
              >
                <div class="PullToRefresh-content">
                  <div
                    class="contentBox chatting-content"
                    ref="chatMain"
                    id="chatMain"
                  >
                    <slot></slot>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <RelateReplies
            :list="toastList"
            :currList="toastCurrList"
            :show="!!toastList.length && isToast && !isTourShow && !isAudioShow"
            @on-ask="onRateAsk"
            v-if="!isOpenChat"
          />

          <!--                        <transition name="fadeInput">-->
          <!--                            <div :class="['questionBox', 'questionPadding', 'questionRadius','padByDevice']" id="tourBox" v-show="isTourShow">-->
          <!--                                <SelectTags :list="tagsList"/>-->
          <!--                                <SelectTour :list="selectList" :show="false" @on-ask="onSelectToast" />-->
          <!--                            </div>-->
          <!--                        </transition>-->

          <transition name="fadeInUp">
            <div
              v-if="isAudioBarShow === 'audio'"
              :class="[isInputShow ? 'audioWrapper' : 'bottomAudioWrapper']"
            >
              <audio-bar />
            </div>
            <div
              v-else-if="isAudioBarShow === 'ximalaya'"
              :class="[isInputShow ? 'audioWrapper' : 'bottomAudioWrapper']"
            >
              <ximalaya-audio-bar />
            </div>
          </transition>

          <transition name="fadeInput">
            <div
              :class="[
                'questionBox',
                'questionPadding',
                'questionRadius',
                'padByDevice',
              ]"
              id="questionBox"
              v-show="isInputShow"
            >
              <QuickReplies
                :list="noticeList"
                :show="!!toastList.length && isToast"
                @on-ask="onQuickAsk"
                v-if="!isOpenChat && !isTourShow && !isAudioShow"
              />
              <QuickReplies
                :list="selectTourList"
                :show="!isTourShow"
                @on-ask="onQuickAsk"
                v-if="isTourShow"
                color="scrollTourTags"
              />
              <QuickReplies
                :list="audioSelectData"
                :show="!isAudioShow"
                @on-ask="onQuickAsk"
                v-if="isAudioShow"
                color="scrollTourTags"
              />
              <div :class="['ComposerPC', 'isCompact']">
                <!--                                    修改input的限制字数-->
                <input
                  id="inputValue"
                  ref="searchInput"
                  type="text"
                  placeholder="有什么想说的在这里说哦~"
                  v-model.trim="inputValue"
                  class="inputCls"
                  v-on:input="onRate"
                  maxlength="1024"
                  @blur="onBlur"
                  :disabled="!homeChat.length || chatLoading"
                />
                <div class="button">
                  <!-- <img
                    src="../assets/img/send.png"
                    alt="发送"
                    class="sendImg"
                    @click="onAsk"
                  /> -->
                  <span  @click="onAsk">发送</span>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { XMplayer } from "@xmly-fem/web-jssdk";
import { parseData, objBlurFun } from "@/utils/utils";
import { TopView, QuickReplies, RelateReplies } from "./View/index";
import SelectTags from "./Use/tags";
import SelectTour from "./Use/select-tour";
import AudioBar from "./Use/audio-bar";
import XimalayaAudioBar from "./Use/ximalaya-audio-bar";

export default {
  name: "PageWrapper",
  components: {
    TopView,
    QuickReplies,
    RelateReplies,
    SelectTags,
    SelectTour,
    AudioBar,
    XimalayaAudioBar,
  },
  props: {},
  data() {
    return {
      inputValue: "",
      isToast: false,
      toastCurrList: [],
    };
  },
  mounted() {
    this.musicPlay();
    // 监听输入框软键盘回车键，点击回车键，软键盘收起
    this.$refs.searchInput.addEventListener("keyup", (e) => {
      if (e.keyCode == 13) {
        this.$refs.searchInput.blur();
        this.onAsk();
      }
    });
  },
  watch: {},
  computed: {
    ...mapState([
      "toastList",
      "noticeList",
      "globalDuration",
      "device",
      "isOpenChat",
      "readNewsId",
      "isInputShow",
      "questionTips",
      "guideTips",
      "isTourShow",
      "selectList",
      "tagsList",
      "audioSelectData",
      "isAudioShow",
      "isAudioBarShow",
      "chatLoading",
      "homeChat",
      "isToastShow",
      "OpenChatID",
      "feedbackType",
      "feedbackDirection"
    ]),
    ...mapState("audio", [
      "fPlayer",
      "xPlayer",
      "isPause",
      "audioCurrentIndex",
    ]),
    selectTourList() {
      const { selectList, tourSelectType } = this.$store.state;
      // console.info('tourSelectType',tourSelectType, selectList)
      return tourSelectType
        ? selectList.filter((it) => {
            return it.value == tourSelectType;
          })[0].children
        : [];
    },
  },
  methods: {
    ...mapMutations([
      "contactDisData",
      "setHomeData",
      "setToastList",
      "setLinkSrc",
      "setGlobalDuration",
      "setChatLoading",
      "setClearTimer",
      "setInputShow",
      "setMaskShowStatus",
      "setTourSelectData",
      "setToastShow",
      "setToastContent",
      "setAudioBarShow",
    ]),
    ...mapMutations("audio", [
      "setAudioList",
      "setAudioCurrentIndex",
      "setAudioCurrentTime",
      "setDuration",
      "setXPlayer",
      "setFPlayer",
    ]),
    ...mapActions([
      "fetchRelate",
      "fetchHome",
      "fetchNotice",
      "discussNews",
      "queryPoke",
      "getTourSelectData",
      "queryTourism",
      "queryAudioSearch",
      "getFakeUser",
      "feedbackDataAsync"
    ]),
    onAsk() {
      let that = this;
      this.isToast = false;
      this.service.pageScrollTo();
      this.setToastList([]);
      // let inputValue = this.inputValue.replace(/(\r\n|\n|\r)/gm, " ")
      if (this.inputValue !== "") {
        this.onRequest(this.inputValue, this.inputValue, false, "input");
      } else {
        return;
      }
    },

    onRequest(name, value, hasClearTimer, type) {
      let that = this;
      this.setChatLoading(true);
      this.setGlobalDuration(0);
      this.setClearTimer(true);
      that.contactDisData([{ content: { right: true, tips: name } }]);
      that.inputValue = "";
      // value = value.replace(/(\r\n|\n|\r)/gm, " ")
      if (this.isOpenChat) {
        switch (this.OpenChatID) {
          case 0:
            {
              that
                .discussNews({
                  payload: { question: value, newsId: this.readNewsId },
                })
                .then((res) => {
                  if (res.length) {
                    that.setChatLoading(false);
                  }
                  cio.track(7, "click", "send_msg", { msg: value });

                  setTimeout(() => {
                    that.service.pageScrollTo();
                  }, 100);
                });
            }
            break;
          case 1:
            {
              that
                .feedbackDataAsync({
                  payload: {
                    content: value,
                    feedbackDirection: that.feedbackDirection,
                    feedbackType: that.feedbackType,
                  },
                })
                .then((res) => {
                  if (res.length) {
                    that.setChatLoading(false);
                  }
                  cio.track(7, "click", "send_msg", { msg: value });

                  setTimeout(() => {
                    that.service.pageScrollTo();
                  }, 100);
                });
            }
            break;
        }
      } else if (this.isAudioShow && type === "button") {
        // that.setAudioList([])
        that.setAudioCurrentIndex(-1);
        setTimeout(() => {
          // this.xPlayer && this.xPlayer.pause()
          that.setAudioCurrentTime(0);
          that.setDuration(0);
          that
            .fetchHome({ payload: { question: value, hasClearTimer } })
            .then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              cio.track(7, "click", "send_msg", { msg: value });
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 100);
            });
        }, 1000);
      } else if (this.isAudioShow && type === "input") {
        // that.setAudioList([])
        that.setAudioBarShow(false);
        that.setAudioCurrentIndex(-1);
        setTimeout(() => {
          that.setAudioCurrentTime(0);
          that.setDuration(0);
          that
            .fetchHome({ payload: { question: value, hasClearTimer } })
            .then((res) => {
              if (res.length) {
                that.setChatLoading(false);
              }
              cio.track(7, "click", "send_msg", { msg: value });
              setTimeout(() => {
                that.service.pageScrollTo();
              }, 100);
            });
        }, 1000);
      } else {
        that
          .fetchHome({ payload: { question: value, hasClearTimer } })
          .then((res) => {
            if (res.length) {
              that.setChatLoading(false);
            }
            cio.track(7, "click", "send_msg", { msg: value });
            setTimeout(() => {
              that.service.pageScrollTo();
            }, 100);
          });
      }
    },

    onRateAsk(value) {
      this.isToast = false;
      this.setToastList([]);
      cio.track(4, "click", "foot_shortcut", { shortcutName: value });
      // cio.track(5,'click', "click_scene",{sceneName:value});
      this.onRequest(value, value, false);
    },

    onRate() {
      let that = this;
      // let inputValue = this.inputValue.replace(/(\r\n|\n|\r)/gm, " ")
      if (this.inputValue !== "") {
        that.setClearTimer(true);
        that.isToast = true;
        that
          .fetchRelate({ payload: { question: this.inputValue } })
          .then((res) => {
            that.toastCurrList = parseData(res, this.inputValue);
          });
      } else if (this.isAudioShow) {
        that.setClearTimer(true);
        that.toastCurrList = [];
        that.isToast = false;
        that.setToastList([]);
      } else {
        that.setClearTimer(false);
        that.toastCurrList = [];
        that.isToast = false;
        that.setToastList([]);
      }
    },
    onBlur() {
      // console.info("onBlur");
      let that = this;
      setTimeout(() => {
        that.setMaskShowStatus(false);
      }, 0);
    },

    onQuickAsk(name, value) {
      //加载完毕才能点击快速访问按钮
      if (!this.chatLoading && this.homeChat.length) {
        this.onRequest(name, value, true, "button");
      }
    },

    onPoke(name, value) {
      let that = this;
      this.setChatLoading(true);
      this.setGlobalDuration(0);
      this.setClearTimer(true);
      that.contactDisData([{ content: { right: true, tips: name } }]);

      that.queryPoke().then((res) => {
        if (res.length) {
          that.setChatLoading(false);
        }
        setTimeout(() => {
          that.service.pageScrollTo();
        }, 100);
      });
    },

    onSelectToast(name, value, id, toastType, children, selectType) {
      let that = this;
      this.setToastShow(true);
      this.setToastContent({
        toastType: toastType,
        selectType,
        list: { name: name, content: children },
      });
      this.setTourSelectData(children);
    },
    // 封面音频专辑自动播放
    musicPlay() {
      // 在这里写，先播放一段空白音频可以兼容不自动播放的浏览器
      // let music = document.getElementById("audioRef");
      this.setFPlayer(document.getElementById("audioRef"));
      !this.isPause && !this.isAudioShow && this.fPlayer.play();
      // 微信自动播放
      document.addEventListener(
        "WeixinJSBridgeReady",
        () => {
          !this.isPause && !this.isAudioShow && this.fPlayer.play();
        },
        false
      );
      // 兼容其他不自动播放的情况
      document.addEventListener(
        "touchstart",
        () => {
          !this.isPause && !this.isAudioShow && this.fPlayer.play();
        },
        false
      );
    },
  },
};
</script>
<style lang="less" scoped>
.PageWrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
  /*margin: 0 auto;*/
  /*height: 9rem;*/
  /*background: #fff;*/
  /*position: absolute;*/
  /*bottom: 0;*/
  /*border-radius: .8rem 0 0 0;*/

  /*position: fixed;*/
  /*bottom: 0;*/
  /*top: 0;*/
  /*left: 0;*/
  /*right: 0;*/

  .fadeInput-enter-active,
  .fadeInput-leave-active {
    transition: opacity 0.5s;
  }

  .fadeInput-enter,
  .fadeInput-leave-to {
    opacity: 0;
  }

  .containerCls {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 100%;
  }

  .childView {
    display: flex;
  }

  .contentBox {
    overflow-y: scroll;
  }

  .tourPaddingBottom {
    padding-bottom: 3rem;
  }
  .inputPaddingBottom {
    padding-bottom: 4rem !important;
  }
  .audioPaddingBottom {
    padding-bottom: 3rem;
  }

  .PullToRefresh-inner {
    overflow: hidden;
    /*min-height:100%;*/
  }

  .PullToRefresh {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    /*padding-bottom: 2rem;*/
  }

  .iosMinHeight {
    min-height: 8rem;
  }

  .MessageContainer {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex: 1;
    flex: 1;
    min-height: 0;
    /*margin-bottom: 1.3rem;*/
  }

  .questionBox {
    /*height: 3.79rem;*/
    box-sizing: border-box;
    padding: 0.43rem;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 102;

    .ComposerPC {
      display: -ms-flexbox;
      display: flex;
      -ms-flex-align: end;
      justify-content: space-between;
      padding: 0.1rem 0;
      margin-top: 0.22rem;
      align-items: center;
    }

    .inputCls {
      width: 7.55rem;
      height: 1.17rem;
      padding: 0 0.43rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: none;
      font-size: 0.37rem;
      background: #FFFAFA;
      border-radius: 0.6rem;
      border: 0.03rem solid #FFF1F1;
      -webkit-appearance: none;
      line-height: 1.17rem;
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      // .sendImg {
      //   width: 1.17rem;
      //   height: 1.17rem;
      // }
          align-items: center;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background-color: #e65757;
        font-size: .36rem;
    color: #fff;
    font-weight: 600;
    }

    .disable {
      background: #f0f2f5;
    }
  }
  .audioWrapper {
    width: 8.72rem;
    height: 2.48rem;
    background: #ffffff;
    box-shadow: 0rem 0.11rem 0.53rem 0rem rgba(63, 142, 247, 0.13);
    border-radius: 0.16rem;
    /*position: fixed;*/
    position: absolute;
    bottom: 2.5rem;
    left: calc(50% - 4.36rem);
    z-index: 101;
  }
  .bottomAudioWrapper {
    width: 8.72rem;
    height: 2rem;
    background: #ffffff;
    box-shadow: 0rem 0.11rem 0.53rem 0rem rgba(63, 142, 247, 0.13);
    border-radius: 0.16rem;
    /*position: fixed;*/
    position: absolute;
    bottom: 0;
    left: calc(50% - 4.36rem);
    z-index: 101;
  }
}
</style>
